import {
  syncAuthenticatedUserContext,
  clearAuthenticatedUserContext,
} from "@/telemetry/appInsights";

export const getAuthToken = () => localStorage.getItem('token');

export const setAuthToken = (token: string) => {
  localStorage.setItem('token', token);
  syncAuthenticatedUserContext(token);
};

export const removeAuthToken = () => {
  localStorage.removeItem('token');
  clearAuthenticatedUserContext();
};

export const isAuthenticated = () => !!getAuthToken();
